import { fieldTypeMap } from 'configurable-form/field-type-map';
import React from 'react';

export function renderFields(field) {
  const Field = fieldTypeMap[field.component];
  return <Field key={field.id} {...field} />;
}
